import { toast } from '@cinesend/ui-kit'

const toastTypes = { success: 'success', error: 'error' }

export const useSnackbar = () => {
  const addMessage = (text, type = 'success', timeout = 4000) => {
    toast({ text, type: toastTypes[type] ?? 'default', duration: timeout ?? Infinity })
  }

  const addErrorMessage = (text) => {
    addMessage(text, 'error', null)
  }

  return {
    addMessage,
    addErrorMessage,
  }
}
